import { useState } from "react";
import { caApi } from "../../../../../backend_urls/caApi";
import "../../../../../css/pages/ca_pages/models/CreateClient.css";

const CreateClient = ({ onClose, onSave }) => {
    const [formData, setFormData] = useState({
        user_full_name: "",
        contact: "",
        email: "",
        password: "",
        user_profile_image: null,
    });

    const [imagePreview, setImagePreview] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setFormData((prev) => ({ ...prev, user_profile_image: file }));
        setImagePreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await caApi.createClient(formData);
        if (response.data.success) {
            onSave(response.data.client);
        }
    };

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div
                className="create-client-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="popup-header">
                    <h2>Add New Client</h2>

                    <button className="close-btn" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>
                            Full Name <span>*</span>
                        </label>

                        <input
                            autoFocus
                            type="text"
                            name="user_full_name"
                            placeholder="Enter client's full name"
                            value={formData.user_full_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Contact Number <span>*</span>
                        </label>

                        <input
                            type="tel"
                            name="contact"
                            placeholder="9876543210"
                            value={formData.contact}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Email Address <span>*</span>
                        </label>

                        <input
                            type="email"
                            name="email"
                            placeholder="client@example.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Clients Temporary Password <span>*</span>
                        </label>

                        <input
                            autoFocus
                            type="text"
                            name="password"
                            placeholder="Enter client's Temporary Password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Profile Image
                            <small> (Optional)</small>
                        </label>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />

                        {imagePreview && (
                            <img
                                src={imagePreview}
                                alt="Preview"
                                className="profile-preview"
                            />
                        )}
                    </div>

                    <div className="popup-actions">
                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={onClose}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="create-btn"
                        >
                            Create Client
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateClient;
